import React from 'react';
import type { NativeStackScreenProps } from '@react-navigation/native-stack';
import type { RootStackParamList } from '../../constants/routes';
import { AttendanceReportScreen } from './AttendanceReportScreen';

type Props = NativeStackScreenProps<RootStackParamList, 'TeamAttendanceReport'>;

/**
 * Team Lead daily attendance — the HR Admin register UI, limited by the
 * backend to the signed-in lead's assigned employees.
 */
export function TeamAttendanceReportScreen(props: Props) {
  return <AttendanceReportScreen {...props} scope="team" />;
}
